import React from 'react';

const Pagination = ({ paginationData, onPageChange }) => {
    if (!paginationData || !paginationData.links) {
        return null; // or return a message indicating no pages available
    }

    const { links } = paginationData;

    return (
        <nav aria-label="Page navigation" className='m-3 pull-right'>
            <ul className="pagination">
                {links.map((link, index) => (
                    <li key={index} className={`page-item ${link.active ? 'active' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => link.url && onPageChange(link.url)}
                            dangerouslySetInnerHTML={{ __html: link.label }}
                        />
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Pagination;
